(function() {
    'use strict';

    angular
        .module('publicGatewayApp')
        .controller('OwnProfileDeleteController',OwnProfileDeleteController);

    OwnProfileDeleteController.$inject = ['$uibModalInstance', 'entity', 'OwnProfile'];

    function OwnProfileDeleteController($uibModalInstance, entity, OwnProfile) {
        var vm = this;

        vm.ownProfile = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            OwnProfile.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
